import { Injectable } from '@angular/core';
import { AvailableBillGatewayAppsModel } from '../models/available-bill-gateway-apps.model';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class BillGatewayAppsService {
  getAvailableBillGatewayApps(availableBillGatewayApps: string[]): AvailableBillGatewayAppsModel[] {
    return availableBillGatewayApps.map(code => this.getBillGatewayApp(code));
  }

  private getBillGatewayApp(code: string): AvailableBillGatewayAppsModel {
    return { code, ...environment.billGatewayApps[code] };
  }
}
